import { SKIP_ERROR_TOAST } from 'src/app/shared/http-context-tokens';
import { map as rxjsmap, switchMap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import {
  CompleteCheckList,
  DeviationIds,
  FoodSafetyManualCompleteChecklist,
  VehiclesCompleteChecklist
} from '../models/complete-checklist';
import { BaseServices } from './../../kuba.services';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaderResponse, HttpContext } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
@Injectable()
export class CompleteCheckListServices {
  constructor(private http: HttpClient) {}

  saveDraft(kind: string, checklist: CompleteCheckList) {
    return this.http.post<number>(`${environment.BASE_URL_V2}/checklists/${kind}/draft`, checklist,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) });
  }

  saveTemperatureDraft(kind: 'food' | 'control', checklist: FoodSafetyManualCompleteChecklist) {
    return this.http.post<number>(`${environment.BASE_URL_V2}/checklists/${kind}/draft`, checklist,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) });
  }

  saveVehicleDraft(checklist: VehiclesCompleteChecklist) {
    return this.http.post<number>(`${environment.BASE_URL_V2}/checklists/vehicle/draft`, checklist,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) });
  }

  // Add Manual Complete checklist
  addAppCompleteCheckList(
    CompleteCheckList: CompleteCheckList,
    ChangedDeviationIds: any
  ) {
    return this.http
      .post(environment.BASE_URL + '/manual/checklist/complete/save', {
        CompleteCheckList: CompleteCheckList,
        ChangedDeviationIds: ChangedDeviationIds
      }).pipe(rxjsmap(result => result));
  }

  // Add Manual Complete checklist
  addFeatureCompleteCheckList(CompleteCheckList: CompleteCheckList) {
    return this.http
      .post(
        environment.BASE_URL + '/features/FeatureManualComplete/save',
        CompleteCheckList
      ).pipe(rxjsmap(result => result));
  }

  SendMailforDeviation(dIds: DeviationIds): Observable<any> {
    if (!dIds.DeviationIds || dIds.DeviationIds.length <= 0) {
      return of(true);
    }

    return this.http
      .post(
        environment.BASE_URL +
          '/features/FeatureManualComplete/sendemaildeviation/',
        dIds
      )
      .pipe(
        map(() => true),
        catchError(() => of(false))
      );
  }

  // get feature checklist data
  getFeatureCheckListData(id: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/features/FeatureManualComplete/get/checklistdata/' +
          id
      ).pipe(rxjsmap(result => result));
  }
  // get feature checklist data
  getManualCheckListData(id: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/manual/checklist/complete/get/checklistdata/' +
          id
      ).pipe(rxjsmap(result => result));
  }

  // get feature complete checklist data
  getFeatureCompleteCheckListData(id: number) {
    return this.http
      .get(environment.BASE_URL + '/features/FeatureManualComplete/get/' + id).pipe(rxjsmap(result => result));
  }

  getRModeFeature() {
    return this.http
      .get<HttpHeaderResponse>(
        environment.BASE_URL + '/rmode-feature/' + BaseServices.BusinessId
      )
      .pipe(
        map((response: HttpHeaderResponse) => {
          return response;
        })
      );
  }

  // get feature complete checklist data
  getManualCompleteCheckListData(id: number) {
    return this.http
      .get(environment.BASE_URL + '/manual/checklist/complete/get/' + id).pipe(rxjsmap(result => result));
  }

  // get app manual checklist data
  getManualChecklistDetails(id: number) {
    return this.http
      .get(environment.BASE_URL + '/manual/0/checklist/retrive/' + id).pipe(rxjsmap(result => result));
  }

  // get app manual checklist data
  getFeatureChecklistDetails(id: number) {
    return this.http
      .get(environment.BASE_URL + '/feature/checklist/' + id).pipe(rxjsmap(result => result));
  }

  // get app manual checklist data
  getFoodSafetyChecklistById(id: number, key: any) {
    return this.http
      .get(environment.BASE_URL + '/' + key + '/CompleteChecklist/' + id).pipe(rxjsmap(result => result));
  }

  GetAllFoodSafetyChecklistData(key: any) {
    return this.http
      .get(
        environment.BASE_URL +
          '/' +
          key +
          '/CompleteFoodSafetyData/' +
          BaseServices.BusinessId
      ).pipe(rxjsmap(result => result));
  }

  GetFoodSafetyChecklistDataByFoodId(fId: number, key: any) {
    return this.http
      .get(
        environment.BASE_URL + '/' + key + '/CompleteFoodSafetyDataById/' + fId
      ).pipe(rxjsmap(result => result));
  }

  SaveFoodSafetyChecklistById(
    FoodSafetyManualCompleteChecklist: FoodSafetyManualCompleteChecklist,
    cultureInfo: string,
    key: any
  ) {
    return this.http
      .put(
        environment.BASE_URL +
          '/' +
          key +
          '/updateCompleteChecklistByFoodId/' +
          cultureInfo,
        FoodSafetyManualCompleteChecklist
      ).pipe(rxjsmap(result => result));
  }

  getCheckListReferenceData() {
    return this.http
      .get(
        environment.BASE_URL +
          '/features/FeatureManualComplete/get/checklistreference'
      ).pipe(rxjsmap(result => result));
  }

  getCurrentDate() {
    return this.http
      .get(environment.BASE_URL + '/features/FeatureManualComplete/currentdate').pipe(rxjsmap(result => result));
  }

  // get app manual checklist data
  getVehiclesChecklistById(id: number, fkey: number) {
    return this.http
      .get(
        environment.BASE_URL + '/vehicle/CompleteChecklist/' + id + '/' + fkey
      ).pipe(rxjsmap(result => result));
  }

  VehiclesChecklistById(
    VehiclesCompleteChecklist: VehiclesCompleteChecklist,
    cultureInfo: string
  ) {
    return this.http
      .put(
        environment.BASE_URL +
          '/vehicle/updateCompleteChecklistByVehicleId/' +
          cultureInfo,
        VehiclesCompleteChecklist
      ).pipe(rxjsmap(result => result));
  }

  // Complete checklist and generate report
  SaveAndCompleteCheckList(
    CompleteCheckList: CompleteCheckList,
    IsScoreIndex: boolean,
    CultureInfo: string
  ) {
    const feature = CompleteCheckList.FeatureFolderId != null;
    const saved = feature
      ? this.addFeatureCompleteCheckList({ ...CompleteCheckList, FeatureFolderId: CompleteCheckList.MovedFolderId })
      : this.addAppCompleteCheckList(CompleteCheckList, { Comments: [], Attachments: [] });
    return saved.pipe(switchMap((result: CompleteCheckList) => this.http.post(
      `${environment.BASE_URL}/complete-checklist/${IsScoreIndex}/${CultureInfo}?kind=${feature ? 'feature' : 'manual'}`,
      { Id: result.Id }
    )));
  }

  getFeatureFolders(featureid: number, featureKey: number) {
    return this.http
      .get(
        environment.BASE_URL +
          '/feature/tree/featurefoldertreedata/' +
          featureid +
          '/' +
          featureKey
      ).pipe(rxjsmap(result => result));
  }

  generateUnderCompletionChecklistReport(
    CompleteCheckList: CompleteCheckList,
    IsScoreIndex: boolean,
    CultureInfo: string
  ) {
    return this.http.post(
      `${environment.BASE_URL}/print-undercompletion-checklist/${IsScoreIndex}/${CultureInfo}?kind=${CompleteCheckList.FeatureFolderId != null ? 'feature' : 'manual'}`,
      { data: CompleteCheckList },
      { responseType: 'blob' }
    );
  }

  // Add FS step-1 Complete checklist
  SaveFirstStepCompleteCheckListForFS(CompleteCheckList: CompleteCheckList) {
    return this.http
      .post(
        environment.BASE_URL +
          '/features/FeatureManualComplete/save/fs-stepone/checklist',
        CompleteCheckList
      ).pipe(rxjsmap(result => result));
  }

  Deletefeaturecompletechecklist(Id: number) {
    return this.http
      .delete(
        environment.BASE_URL +
          '/features/FeatureManualComplete/delete/fs-stepone/' +
          Id
      ).pipe(rxjsmap(result => result));
  }
}
